
const co = require('./internal/co')
const ob = require('./internal/ob')

module.exports = Object.assign(
  co,
  ob
)
